import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate(); 
  return (
    <div className="bg-gradient-to-r from-blue-100 via-purple-200 to-orange-100 min-h-screen flex flex-col justify-center">
      
      {/* Top Thin Section */}
      <header className="absolute inset-x-0 top-0 z-50">
        <div className="bg-gray-800 text-white text-xs sm:text-sm text-center py-2 flex items-center justify-center space-x-2 z-50 relative">
          <span>Created by</span>
          <a 
            href="https://www.linkedin.com/in/gowtham-kamalasekar" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex items-center gap-1 font-semibold text-blue-400 hover:text-blue-300 underline transition duration-200"
          >
            <img src="/linkedin_icon.png" alt="LinkedIn" className="w-4 h-4" />
            Gowtham T K
          </a>
        </div>

        {/* Navbar */}
        <nav className="">
          <div className="max-w-6xl mx-auto px-4">
            <div className="flex justify-between items-center py-4">
              
              {/* Logo */}
              <a href="/" className="flex items-center">
                <img src="/logo.png" alt="Logo" className="h-12 w-auto" />
              </a>

              {/* Navigation Links */}
              <div className="hidden md:flex space-x-6">
                <a href="#blog" className="text-gray-700 hover:text-blue-500">Blog</a>
                <a href="#review" className="text-gray-700 hover:text-blue-500">Reviews</a>
                <a href="#about" className="text-gray-700 hover:text-blue-500">About</a>
                <a href="#pricing" className="text-gray-700 hover:text-blue-500">Pricing</a>
                <a href="#location" className="text-gray-700 hover:text-blue-500">Location</a>
                <a href="#coach" className="text-gray-700 hover:text-blue-500">Coach</a>
                <a href="#faq" className="text-gray-700 hover:text-blue-500">FAQ</a>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <div className="relative isolate px-6 pt-32 lg:px-8 flex flex-col items-center justify-center min-h-screen">
        <div className="mx-auto max-w-2xl py-16 sm:py-32 lg:py-40 text-center">
          <img
            alt="Pavan's Badminton Academy Logo"
            src="/logo.png"
            className="h-24 w-auto mx-auto mb-4"
          />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-gray-900">
            Pavan's Badminton Academy
          </h1>
          <p className="mt-4 text-lg text-gray-500 sm:text-xl">
            Smash your limits! 🏸 Train anytime, rise every time.
          </p>
          
          {/* Social Links */}
          <div className="mt-6 flex flex-col items-center space-y-4">
            {/* WhatsApp Contact Button */}
            <a
              href="https://wa.me/+918100376761"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500"
            >
              <img src="/whatsapp_icon.png" alt="WhatsApp" className="w-5 h-5" /> 
              Contact on WhatsApp
            </a>

            {/* Social Media Icons on Next Line */}
            <div className="flex space-x-6">
              <a href="tel:+918100376761" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="text-gray-600 hover:text-gray-900" size={20} />
              </a>
              <a href="https://instagram.com/nathanvaithia" target="_blank" rel="noopener noreferrer">
                <Instagram className="text-gray-600 hover:text-gray-900" size={20} />
              </a>
              <a href="https://facebook.com/vaithia.nathan.923" target="_blank" rel="noopener noreferrer">
                <Facebook className="text-gray-600 hover:text-gray-900" size={20} />
              </a>
            </div>
          </div>

          <div className="mt-6 flex items-center justify-center space-y-4 m-4">
              <button
                onClick={() => navigate("/membership")}
                className="mt-4 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
              >
                Go to Membership Page to Book Your Membership
              </button>
          </div>

        </div>
      </div>
    </div>
  );
}
